import { render, staticRenderFns } from "./VerificationEmailSent.vue?vue&type=template&id=6ec83460&scoped=true&"
import script from "./VerificationEmailSent.vue?vue&type=script&lang=ts&"
export * from "./VerificationEmailSent.vue?vue&type=script&lang=ts&"
import style0 from "./VerificationEmailSent.vue?vue&type=style&index=0&id=6ec83460&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec83460",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VIcon,VLayout,VRow})
